import type { IJiraIssueRow } from '@skystone/shared';
import { jiraIssuesApi } from '@/services/jira-issues-api';
import { useApi } from '@/hooks/useApi';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { ColumnDef } from '@/components/ui';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const jiraIssueColumns: ColumnDef<IJiraIssueRow>[] = buildRawColumns<IJiraIssueRow>([
  { key: 'id', header: 'ID' },
  { key: 'issueKey', header: 'Issue Key' },
  { key: 'issueType', header: 'Issue Type' },
  { key: 'currentStatus', header: 'Current Status' },
  { key: 'projectId', header: 'Project ID' },
  { key: 'teamId', header: 'Team ID' },
  { key: 'lastUpdated', header: 'Last Updated' },
  { key: 'createdAt', header: 'Created At' },
]);

export function TblJiraIssuesPage() {
  const { data: rows, loading, error } = useApi(() => jiraIssuesApi.getAll(), []);

  if (loading && !rows) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - jira_issues" subtitle={buildStandardTblSubtitle()} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={jiraIssueColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('jira_issues')}
      />
    </PageContainer>
  );
}
